{
  "account_is_inactive": "Su cuenta está inactiva",
  "addons_email_marketing": "Email marketing",
  "addons_email_marketing_description": "Cree newsletters, envíe campañas dirigidas y analice los resultados. Organice sus contactos en listas y segmentos. Haga crecer su lista de suscriptores con formularios de registro y elija entre cientos de plantillas responsivas.",
  "addons_email_marketing_lower": "<p>Suscríbase ahora para:</p><ul><li><strong>Crear, enviar y analizar campañas dirigidas</strong></li><li>Organizar a sus <strong>contactos en listas</strong> y <strong>segmentos específicos</strong></li><li>Aumentar su lista de suscriptores usando <strong>formularios de registro, pop-ups</strong> o <strong>formularios inline</strong> en su sitio web</li><li>Acceder a más de <strong>700 plantillas gratuitas</strong>, listas para usar, <strong>organizadas por categoría</strong> y <strong>totalmente responsivas</strong></li><li>Todo en cumplimiento con la Ley CAN-SPAM y la GDPR</li></ul><p><a href=\"https://emailchef.com/es/caracteristicas/\" target=\"_blank\">Conozca más</a> sobre nuestro servicio de email marketing.</p>",
  "addons_email_marketing_tryitforfree": "Comience su Prueba Gratuita",
  "addons_email_marketing_upper": "<p>Cree campañas de email marketing con un servicio de envíos profesional y muy fácil de usar. Los servidores de TurboSMTP le garantizan <strong>las mejores tasas de entrega</strong> y siempre <strong>en cumplimiento de la GDPR</strong>.<p>",
  "addons_email_validator": "Validador de Email",
  "addons_email_validator_description": "El archivo cargado debe contener solo una dirección de correo electrónico en cada fila. Los formatos de archivo soportados son csv y txt. O seleccione un archivo para importar.",
  "addons_emailmarketing_title": "Email marketing",
  "addons_title": "Addons",
  "analytics_average_click": "Retraso promedio de clics",
  "analytics_average_click_description": "Tiempo promedio transcurrido entre la apertura y el hacer clic",
  "analytics_average_first": "Retraso promedio de la primera apertura",
  "analytics_average_first_description": "Tiempo promedio transcurrido entre la entrega y la apertura",
  "analytics_average_opens": "Tasa promedio de apertura de correo",
  "analytics_average_opens_description": "Promedio del número veces que se abrió un correo.",
  "analytics_chart_frequency_d": "Diaria",
  "analytics_chart_frequency_h": "Por hora",
  "analytics_chart_frequency_m": "Mensual",
  "analytics_chart_frequency_w": "Semanal",
  "analytics_charts": "Gráficas",
  "analytics_clicks_title": "No hay clics",
  "analytics_date": "Fecha",
  "analytics_description_clicks_empty": "No se encontraron datos de clics.",
  "analytics_description_empty": "No hay datos para la fecha seleccionada",
  "analytics_event_bounce": "Rebotado",
  "analytics_event_clicks": "Clicado",
  "analytics_event_delivered": "Entregado",
  "analytics_event_drop": "Rechazado",
  "analytics_event_opens": "Abierto",
  "analytics_event_queued": "En cola",
  "analytics_event_sent": "Entregado",
  "analytics_event_spam": "Spam",
  "analytics_event_unsubscribes": "Desuscrito",
  "analytics_events": "Eventos",
  "emailvalidator_validate_freecredits_used": "Se utilizarán los siguientes créditos gratuitos:",
  "analytics_events_all": "Todos",
  "analytics_events_bounce": "Rebotados",
  "analytics_events_bounce_tooltip": "El porcentaje y la cantidad de correos rechazados por los servidores de sus destinatarios.",
  "analytics_events_bounces": "Rebotes",
  "analytics_events_clicks": "Clicados",
  "analytics_events_clicks_tooltip": "El porcentaje y la cantidad de personas que hicieron clic en al menos uno de los enlaces de su mensaje.",
  "analytics_events_delivered": "Entregados",
  "analytics_events_delivered_tooltip": "El porcentaje y número de mensajes enviados entregados con éxito.",
  "analytics_events_drop": "Rechazados",
  "analytics_events_drop_tooltip": "Estos correos se excluyen porque anteriormente se desuscribieron, generaron rebotes o reportes por spam. Los correos rechazados se encuentran en la sección de Anulaciones.",
  "analytics_events_opens": "Abiertos",
  "analytics_events_opens_tooltip": "El porcentaje y la cantidad de correos electrónicos abiertos por sus destinatarios.",
  "analytics_events_queued": "Encolados",
  "analytics_events_queued_tooltip": "El porcentaje del total de emails que aún están en la cola de envío.",
  "analytics_events_sent": "Entregados",
  "analytics_events_spam": "Spam",
  "analytics_events_spam_tooltip": "El porcentaje de destinatarios que reportaron su mensaje como spam.\n",
  "analytics_events_unsubscribes": "Desuscritos",
  "analytics_events_unsubscribes_tooltip": "El porcentaje de solicitudes de desuscripción resultantes de los mensajes entregados con éxito.",
  "analytics_file": "Nombre del archivo",
  "analytics_filterby_domain": "Dominio",
  "analytics_filterby_recipient": "Destinatario",
  "analytics_filterby_sender": "Remitente",
  "analytics_filterby_subject": "Asunto",
  "analytics_numbers": "Números",
  "analytics_openclick": "Análisis de aperturas/clics",
  "analytics_overview": "Resumen General",
  "analytics_percentage": "Porcentaje",
  "analytics_reason": "Razón",
  "analytics_recipient": "Destinatario",
  "analytics_sender": "Remitente",
  "analytics_status": "Estado",
  "analytics_subject": "Asunto",
  "analytics_temporary_error": "Ha ocurrido un error temporal. Por favor intente más tarde",
  "analytics_title": "Reportes",
  "analytics_topforopens": "Top de aperturas",
  "analytics_total_emails": "Emails importados",
  "analytics_total_processed": "Emails procesados",
  "analytics_upload_date": " Fecha de importación",
  "and": "y",
  "annually": "Anualmente",
  "authentication_expired": "Su sesión ha expirado. Por favor ingrese nuevamente",
  "billing_changepassword_description": "Cambia tu contraseña en esta área. Esta contraseña se usa solo para acceder al Dashboard.",
  "billing_changepassword_title": "Cambiar contraseña",
  "billing_contact_were_not_found": "No se encontró el contacto de facturación.",
  "billing_contacts_address": "Dirección",
  "billing_contacts_address2": "Dirección 2",
  "billing_contacts_billing": "Emails sobre facturación: facturas y recordatorios de facturación",
  "billing_contacts_button_add": "Agregar",
  "billing_contacts_button_edit": "Editar",
  "billing_contacts_city": "Ciudad",
  "billing_contacts_company": "Nombre de la empresa",
  "billing_contacts_country": "País",
  "billing_contacts_domain_email": "Services",
  "billing_contacts_editcontact": "Editar Contacto",
  "billing_contacts_email": "Email",
  "billing_contacts_empty": "Los correos de notificación se enviarán a la dirección de su cuenta principal. Puede agregar más direcciones para recibir las notificaciones en destinatarios adicionales.",
  "billing_contacts_firstname": "Nombre",
  "billing_contacts_general_email": "General",
  "billing_contacts_invoice_email": "Facturas",
  "billing_contacts_lastname": "Apellido",
  "billing_contacts_marketing": "Correos sobre servicio: avisos de renovación, confirmaciones de registro, etc.",
  "billing_contacts_phone": "Teléfono",
  "billing_contacts_products": "Correos sobre productos: detalles del pedido, correos electrónicos de bienvenida, etc.",
  "billing_contacts_products_email": "Productos",
  "billing_contacts_slide_description": "Los correos se enviarán a la dirección de su cuenta principal. También puede agregar más direcciones para enviar notificaciones a destinatarios adicionales.",
  "billing_contacts_slide_title": "Agregar Nuevo Contacto",
  "billing_contacts_stateregion": "Estado/Región/Provincia",
  "billing_contacts_subscriptions": "Suscripciones",
  "billing_contacts_support": "Correos de soporte: permita que este usuario abra tickets en su cuenta.",
  "billing_contacts_support_email": "Soporte",
  "billing_contacts_terms": "He leído y acepto la 'Política de Privacidad' y los 'Términos y Condiciones'",
  "billing_contacts_title": "Agregar Contactos",
  "billing_contacts_transactional": "Correos en general: anuncios generales y recordatorios de contraseñas",
  "billing_contacts_zip": "Código Postal",
  "billing_details_contact_above": "Enviar solo al contacto predeterminado",
  "billing_emails_sentdate": "Fecha de Envío",
  "billing_emails_subject": "Asunto",
  "billing_invoice_date": "Fecha de Envío",
  "billing_invoice_duedate": "Fecha de vencimiento",
  "billing_invoice_number": "Número",
  "billing_invoice_status": "Estado",
  "billing_invoice_status_cancelled": "Cancelado",
  "billing_invoice_status_paid": "Pagado",
  "billing_invoice_status_refunded": "Reembolsado",
  "billing_invoice_status_unpaid": "Sin pagar",
  "billing_invoice_total": "Total",
  "billing_product_payment_method_banktransfer": "Transferencia Bancaria",
  "billing_product_paymentmethod_avangate": "Tarjeta de Crédito (Verizon former 2Checkout)",
  "billing_product_paymentmethod_stripe": "Tarjeta de Crédito (Stripe)",
  "button_add_contact": "Agregar Contacto",
  "button_add_filter": "Agregar Filtro",
  "button_add_plan": "Comprar un nuevo plan",
  "button_add_sender": "Agregar Remitente",
  "button_add_subaccount": "Agregar Sub-Cuenta",
  "button_add_suppression": " Añadir Correo",
  "button_add_template": "Agregar plantilla",
  "button_addbcc": "Añadir CCO",
  "button_addfooter": "Agregar Pie de página",
  "button_advanced_search": "Búsqueda Avanzada",
  "button_apply": "Aplicar",
  "button_back": "Volver",
  "button_basic_search": "Búsqueda Simple",
  "button_buycredits": "Comprar créditos",
  "button_cancel": "Cancelar",
  "button_close": "Cerrar",
  "button_contact_us": "Contacta con nosotras",
  "button_copy": "Copiar",
  "button_create": "Crear",
  "button_createalert": "Crear Alerta",
  "button_delete": "Eliminar",
  "button_delete_all": "Eliminar todo",
  "button_delete_filtered": "Eliminar Filtrados",
  "button_delete_selected": "Eliminar Seleccionados ({n})",
  "button_edit": "Editar",
  "button_export": "Exportar",
  "button_import": "Importar archivo",
  "button_limits": "Definir Límites",
  "button_more": "Ver más",
  "button_next": "Siguiente",
  "button_open_ticket": "Abrir un nuevo ticket",
  "button_pay": "Pagar ahora ",
  "button_refresh": "Actualizar",
  "button_reload": "Recargar",
  "button_request_cancellation": "Solicitar Cancelación",
  "button_reset": "Limpiar",
  "button_returnlist": "Regresar a la lista",
  "button_save": "Guardar",
  "button_search": "Buscar",
  "button_select_fromdevice": "Seleccionar archivos desde su dispositivo",
  "button_submit_ticket": "Enviar ticket ",
  "button_unsubscribe": "Agregar Link de Desuscripción",
  "button_update": "Actualizar",
  "button_update_template": "Actualizar Plantilla",
  "button_update_unsubscribe": "Actualizar Link de Desuscripción",
  "button_updatealert": "Actualizar Alerta",
  "button_updatebcc": "Actualizar CCO",
  "button_updatefooter": "Actualizar Pie de Página",
  "button_upgrade": "Actualizar",
  "button_upload": "Subir",
  "cancel": "Cancelar",
  "choose": "Elegir",
  "clear": "Limpiar",
  "confirm_password_is_missing": "La confirmación de contraseña es obligatoria",
  "contains": "Contiene",
  "dashboard_clicked": "Clicados",
  "dashboard_delivered": "Entregados",
  "dashboard_emails_sent": "Emails totales",
  "dashboard_emails_sent_out_of": "Emails enviados de",
  "dashboard_gotoanalytics": "Ir a Analíticas",
  "dashboard_new_version": "¡Una versión actualizada está disponible!",
  "dashboard_new_version_cancel": "OK",
  "dashboard_new_version_description": "Guarde su trabajo primero y luego vuelva a cargar la página,<br> o presione \"Actualizar ahora\" para cargar una nueva versión.",
  "dashboard_new_version_ok": "Actualizar ahora",
  "dashboard_plan_emails": "emails",
  "dashboard_plan_label": "Plan",
  "dashboard_plan_label_interval": "Plan {interval}",
  "dashboard_plan_limit_unit_daily": "día",
  "dashboard_plan_limit_unit_monthly": "mes",
  "dashboard_plan_limit_unit_yearly": "año",
  "dashboard_recent_email_activities": "Actividad de envíos recientes",
  "dashboard_try": "Está utilizando una \"prueba gratuita\". Para ver el panel completo:",
  "dateAfter": "Fecha es después",
  "dateBefore": "Fecha es antes",
  "dateIs": "Fecha es",
  "dateIsNot": "Fecha no es",
  "datepicker_last_3_months": "Últimos 3 meses",
  "datepicker_last_30days": "Últimos 30 días",
  "datepicker_last_month": "Último mes",
  "datepicker_last_sevendays": "Últimos 7 días",
  "datepicker_last_week": "Último semana",
  "datepicker_last_year": "Último año",
  "datepicker_this_month": "Este mes",
  "datepicker_this_year": "Este año",
  "datepicker_today": "Hoy",
  "datepicker_yesterday": "Ayer",
  "delete_all_bounce": "Borrar todas las devoluciones",
  "delete_all_manual": "Borrar entradas manuales",
  "delete_all_spam": "Borrar reportes de spam",
  "delete_all_unsubscribe": "Borrar todas las desuscripciones",
  "delete_fist_login_dont": "No mostrar este mensaje de nuevo.",
  "delete_fist_login_one": "<h3>Bienvenido al panel avanzado de turboSMTP.</h3><p>Consulte estadísticas en tiempo real sobre sus campañas de correo electrónico<br>y mejore sus resultados con herramientas profesionales.</p><h4>Por favor siga las instrucciones para configurar su panel.</h4>",
  "delete_fist_login_three_a": "Por favor ingrese el nombre del servidor SMTP en su cliente de correo.",
  "delete_fist_login_three_b": "<p><strong class=\"font-xxl\">pro.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_b_eu": "<p><strong class=\"font-xxl\">pro.eu.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_c": "No olvide configurar los registros DNS en su dominio <br>Encuentre las configuraciones en 'Configuraciones'.",
  "delete_fist_login_two_a": "<h3>Seguimiento de aperturas</h3><p>Permite que turboSMTP rastree las tasas de apertura de sus mensajes.</p>",
  "delete_fist_login_two_b": "<h3>Seguimiento de clics</h3><p>Permite que turboSMTP rastree las tasas de clics de sus mensajes</p>",
  "editor_quill_button_title": " Mostrar código HTML",
  "editor_quill_cancel_text": "Cancelar",
  "editor_quill_msg": "Editar el contenido en formato HTML",
  "editor_quill_ok_text": "OK",
  "emails_month": "emails/mes",
  "emailvalidator_add_file": "Agregar archivo",
  "emailvalidator_add_form_errors": "Errores de Formulario",
  "emailvalidator_add_form_nofile_selected": "No ha seleccionado un archivo",
  "emailvalidator_add_value": "Puede agregar entre",
  "emailvalidator_attention": "¡Aviso!",
  "emailvalidator_available": "créditos gratuitos",
  "emailvalidator_balance_description": "Su saldo actual es",
  "emailvalidator_balance_title": "Su saldo de validación",
  "emailvalidator_buy_extra_credit": "Compre saldo adicional",
  "emailvalidator_complete": "Completar",
  "emailvalidator_confirm_delete_label": "Confirmar acción",
  "emailvalidator_confirm_delete_text": "¿Realmente desea borrar esta lista?",
  "emailvalidator_contact_support": "<a href=\"https://serversmtp.com/en/submitticket.php\" target=\"_blank\">Contactar a soporte  <i class=\"ml-2 pi pi-external-link\"></i></a>",
  "emailvalidator_cost_per_email": "El costo por email es",
  "emailvalidator_date": "Fecha de creación:",
  "emailvalidator_day": "Día",
  "emailvalidator_details_empty": "Sin elementos al interior",
  "emailvalidator_domain": "Dominio",
  "emailvalidator_domain_age": "Edad del dominio",
  "emailvalidator_email": "Email",
  "emailvalidator_email_addesses": "direcciones de correo",
  "emailvalidator_empty": "El archivo cargado debe contener solo una dirección de correo electrónico en cada fila. Los formatos de archivo soportados son csv y txt. O seleccione un archivo para importar.",
  "emailvalidator_entry_details": "Detalles de Validación",
  "emailvalidator_error": "Error",
  "emailvalidator_error_contact_support": "Error: ¡Contacte a soporte técnico!",
  "emailvalidator_expiring": "Expira el",
  "emailvalidator_export": "Exportar",
  "emailvalidator_free_email": "Dominio gratuito",
  "emailvalidator_how_many": "¿Cuántas direcciones de correo desea validar?",
  "emailvalidator_list_contains": "La lista cargada contiene",
  "emailvalidator_list_not_removed": "Error al remover la lista",
  "emailvalidator_list_removed": "La Lista ha sido eliminada con éxito.",
  "emailvalidator_mx_record": "Registro MX",
  "emailvalidator_please_enter_amout": "Ingrese la cantidad que desea agregar a su billetera virtual.",
  "emailvalidator_price_calculator": "Calculadora de Precios",
  "emailvalidator_price_email": " Precio por Email",
  "emailvalidator_process_now": "Procesar ahora",
  "emailvalidator_refresh": "Actualizar",
  "emailvalidator_slide_description": "El archivo debe contener sólo una columna que incluya todas las direcciones de correo que desea importar.",
  "emailvalidator_slide_details_description": "Los formatos soportados son csv o txt.",
  "emailvalidator_slide_details_title": "Arrastre y suelte su archivo aquí.",
  "emailvalidator_slide_manually_description": "Copie y pegue varias direcciones de correo en la sección de abajo, separélas con un espacio vacío.",
  "emailvalidator_slide_manually_title": "Agregar Manualmente",
  "emailvalidator_slide_placeholder": "email1@yourdomain.com, email2@yourdomain.com",
  "emailvalidator_smpt_provider": "Proveedor SMTP",
  "emailvalidator_status": "Estado",
  "emailvalidator_status_abuse": "Abuso",
  "emailvalidator_status_catch_all": "Catch-All",
  "emailvalidator_status_do_not_mail": "Do not mail",
  "emailvalidator_status_invalid": "Inválido",
  "emailvalidator_status_spamtrap": "Spam",
  "emailvalidator_status_unknown": "Desconocido",
  "emailvalidator_status_valid": "Válido",
  "emailvalidator_title": "Validador de Email",
  "emailvalidator_total_cost": "El costo total es",
  "emailvalidator_upload_warning": "Su saldo de limpieza actual es {current_balance} Necesita comprar {needed_balance} de crédito adicional para validar esta lista...",
  "emailvalidator_validate_list": "Validar Lista",
  "emailvalidator_validate_now": "Validar ahora",
  "emailvalidator_validated_lists": "Listas Validadas",
  "emailvalidator_validation_date": "Fecha de Validación",
  "emailvalidator_value": "Valor",
  "emailvalidator_you_have": "Usted tiene",
  "empty_authorization_token": "Falta el token de autorización",
  "empty_request_body": "La solicitud está incompleta",
  "endsWith": "Termina con",
  "equals": "Igual",
  "error": "error",
  "file_too_large": "Necesita revisar el tamaño máximo de los archivos a importar",
  "filter": "Filtro",
  "filter_by": "Filtrar por",
  "filter_fuzzy": "Búsqueda inteligente",
  "filter_fuzzy_description": "Habilite esta función para mostrar resultados similares al elemento de la búsqueda.",
  "filter_placeholder_analytics": "Buscar...",
  "filter_placeholder_suppressions": "Buscar...",
  "filter_suppressions_placeholder": "Busque por destinatario, remitente, asunto del correo o motivo de anulación",
  "filters_show": "Mostrar filtros",
  "filters_hide": "Ocultar filtros",
  "first_login_step": "Paso {n}",
  "forgot_password_changed": "Su contraseña ha sido cambiada exitosamente.",
  "forgot_password_click": "Clique aquí",
  "forgot_password_confirm": "Confirme su contraseña",
  "forgot_password_done": "¡Listo!",
  "forgot_password_donot_match": "Las contraseñas no coinciden",
  "forgot_password_email_not_found": "Dirección de correo no encontrada",
  "forgot_password_enter_email": "Ingrese su dirección de correo",
  "forgot_password_error": "Ocurrió un error al cambiar su contraseña.",
  "forgot_password_expired": "El correo enviado para restablecer su contraseña ha caducado.",
  "forgot_password_pick": "Seleccione una contraseña",
  "forgot_password_please_reset": "Por favor ingrese su contraseña",
  "forgot_password_recovery_email_sent": "El email de recuperación ha sido enviado",
  "forgot_password_resend": "para enviar el email nuevamente.",
  "forgot_password_reset": "Restablezca su contraseña",
  "forgot_password_send_password_reset_link": "Enviar link para restablecer contraseña",
  "forgot_password_sent_email_to_update_password": "Acabamos de enviarle un correo con un enlace para actualizar su contraseña.",
  "forgot_password_set": "Establecer nueva contraseña",
  "forgot_password_should_have": "La contraseña debe contener",
  "forgot_password_suggestions": "<li>Al menos una minúscula</li> <li>Al menos una mayúscula</li><li>Al menos un número</li><li>Mínimo 10 caracteres</li>",
  "forgot_password_switch": "Cambiar a Iniciar Sesión",
  "forgot_password_switch_to_login": "Cambiar a Iniciar Sesión",
  "forgot_password_token_is_missing": "Falta el token de contraseña olvidada",
  "forgot_password_unable_to_send": "No se puede enviar el email",
  "forgot_password_username": "Email de usuario",
  "forgot_password_we_will_send_you": "Le enviaremos un enlace de recuperación de contraseña.",
  "free_account": "Cuenta Gratuita",
  "friday": "Viernes",
  "fuzzy_tooltip": "Habilite esta función para mostrar resultados similares al elemento de la búsqueda.",
  "goto_emailmarketing": "Ir a email marketing",
  "goto_emailvalidator": "Ir a Validador de Email",
  "gt": " Más grande que",
  "gte": "Más grande o igual a",
  "header_menu_support": "https://serversmtp.com/multilanguage-customer-support/",
  "internal_server_error_try_again": "Ocurrió un error interno del servidor. Por favor, inténtelo de nuevo más tarde.",
  "invalid_authorization_token": "El token de autorización no es válido",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "El valor límite debe ser al menos 1",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "El valor de la página debe ser al menos 1",
  "invalid_value_for_orderby_parameter": "El parámetro 'ordenar por' no es válido.",
  "invalid_value_for_the_parameter_type": "Valor no válido para el tipo de parámetro",
  "invoice_not_found": "Factura no encontrada",
  "is": "Es",
  "isNot": "No es",
  "jwt_error_full_details": "Detalles completos",
  "jwt_error_status": "Estado HTTP",
  "jwt_error_url": "URL",
  "jwt_url_not_exists": "La siguiente URL no existe",
  "l_allrights": "Todos los derechos reservados",
  "l_antispam_policy": "Política Anti Spam",
  "l_copyright": "© turboSMTP 2010 - ",
  "l_dont_have_account": "¿Aún no tiene una cuenta?",
  "l_email_address": "Dirección de correo",
  "l_forgot_password": "¿Olvidó su contraseña?",
  "l_login": "Iniciar sesión",
  "l_password": "Contraseña",
  "l_remember_me": "Mantener iniciada mi sesión",
  "l_sign_up_here": "Regístrese aquí",
  "l_username_email": "Email de usuario",
  "l_welcome_back": "Bienvenido de vuelta",
  "language_changed_label": "Ha cambiado el idioma",
  "language_changed_message": "Para aplicar los cambios de idioma, recargue la página",
  "language_changed_reload": "Recargar",
  "lt": "Menos que",
  "lte": "Menos que o igual a",
  "m_accountinfo": "Información de la Cuenta",
  "m_analytics": "Analiticas",
  "m_billing": "Facturas Pro forma",
  "m_dashboard": "Tablero",
  "m_emailsentout": "emails enviados",
  "m_emailvalidator": "Validador de Emails",
  "m_messages": "Mensajes del Sistema",
  "m_monthly": "Mensual ",
  "m_myaccount": "Mi Cuenta",
  "m_mydetails": "Mi Cuenta",
  "m_noplans": "No hay Planes",
  "m_of": "de",
  "m_products": "Mis Productos",
  "m_savechanges": "Guardar cambios",
  "m_settings": "Configuraciones",
  "m_subaccounts": "Subcuentas",
  "m_suppressions": "Anulaciones",
  "m_tickets": "Mis Tickets",
  "m_validuntil": "Válido hasta",
  "matchAll": "Coincidir Todo",
  "matchAny": "Coincidir Alguno",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "Valor faltante o inválido proporcionado para la variable WhiteLabeled",
  "missing_required_parameter": "Falta un parámetro requerido",
  "missing_required_parameter_email": "Hace falta el correo",
  "missing_required_parameter_from": "Los datos \"De\" hacen falta",
  "missing_required_parameter_to": "Los datos \"a\" hacen falta",
  "missing_required_parameter_tz": "Los datos \"tz\" hacen falta",
  "modal_confirmation": "Confirmación",
  "monday": "Lunes",
  "monthly": "Mensual",
  "my_account_title": "Mi Cuenta",
  "myaccount_2fa_title": "Autenticación de dos factores",
  "myaccount_2fa_description": "Mejore la seguridad de su cuenta habilitando la autenticación de dos factores (2FA). Esto añade una capa adicional de protección a su cuenta.",
  "myaccount_2fa_card_description": "Habilite la autenticación de dos factores para proteger su cuenta.",
  "myaccount_2fa_select_method": "Seleccionar método de autenticación",
  "myaccount_2fa_method": "Método de autenticación",
  "myaccount_2fa_method_placeholder": "Elija un método de autenticación",
  "myaccount_2fa_otp_description": "Use una aplicación de autenticación (como Google Authenticator o Authy) para generar códigos basados en tiempo.",
  "myaccount_2fa_email_description": "Reciba códigos de verificación por correo electrónico.",
  "myaccount_2fa_sms_description": "Reciba códigos de verificación por SMS.",
  "myaccount_2fa_none_description": "Deshabilite la autenticación de dos factores para su cuenta.",
  "myaccount_2fa_scan_qr": "Escanear código QR",
  "myaccount_2fa_scan_qr_description": "Escanee este código QR con su aplicación de autenticación para configurar la autenticación de dos factores.",
  "myaccount_2fa_manual_entry": "O ingrese este código manualmente:",
  "myaccount_2fa_copy_secret": "Copiar al portapapeles",
  "myaccount_2fa_secret_copied": "Clave secreta copiada al portapapeles",
  "myaccount_2fa_verify_code": "Verificar código",
  "myaccount_2fa_enter_code": "Ingresar código de verificación",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "Ingrese el código de 6 dígitos de su aplicación de autenticación para completar la configuración.",
  "myaccount_2fa_method_updated": "Método de autenticación de dos factores actualizado exitosamente",
  "myaccount_2fa_otp_enabled": "Autenticación de dos factores habilitada exitosamente",
  "myaccount_2fa_current_status": "Estado actual",
  "myaccount_2fa_status": "Estado de la autenticación de dos factores",
  "myaccount_2fa_status_disabled": "Deshabilitado",
  "myaccount_2fa_error_no_keycloak_id": "No se puede configurar 2FA: ID de usuario no encontrado",
  "myaccount_2fa_error_invalid_code": "Código de verificación inválido. Por favor, inténtelo de nuevo.",
  "myaccount_2fa_error_generic": "Ocurrió un error al configurar la autenticación de dos factores",
  "myaccount_2fa_enabled": "Habilitado",
  "myaccount_2fa_disabled_label": "Deshabilitado",
  "myaccount_2fa_disabled": "Autenticación de dos factores deshabilitada exitosamente",
  "myaccount_account_details": "Mi Cuenta",
  "myaccount_billing": "Facturas Pro forma",
  "myaccount_billing_cancellation_contact_support": "Contactar con soporte",
  "myaccount_billing_cancellation_endofcycle_note": "Su suscripción permanecerá activa hasta el final de su período de facturación actual, tras lo cual no se renovará.",
  "myaccount_billing_cancellation_proceed": "Continuar con la cancelación",
  "myaccount_billing_cancellation_reason": "Razon de la cancelacion",
  "myaccount_billing_cancellation_select_reason": "Seleccione una razón",
  "myaccount_billing_cancellation_support_text": "Antes de continuar, nuestro equipo de soporte podría ayudarle a resolver su problema sin necesidad de cancelar. ¿Desea contactarnos primero?",
  "myaccount_billing_contacts": "Administrar contactos",
  "myaccount_billing_contacts_description": "Todos los correos se enviarán a la dirección de su cuenta principal. Puede ingresar más direcciones para enviar las comunicaciones a destinatarios adicionales.",
  "myaccount_billing_description": "En esta sección puede encontrar las facturas pro forma emitidas antes de las facturas con impuestos.<br> Las facturas con impuestos se le enviarán por correo electrónico.",
  "myaccount_billing_details": "Datos de la Cuenta y Facturación",
  "myaccount_billing_details_address": "Dirección",
  "myaccount_billing_details_address2": "Dirección 2",
  "myaccount_billing_details_billing_company_name": "Razón Social",
  "myaccount_billing_details_billing_contact": "Enviar facturas pro forma a una dirección distinta a la dirección de la cuenta",
  "myaccount_billing_details_billing_vat": "VAT /P.IVA/C.F.",
  "myaccount_billing_details_billing_website": "Sitio Web",
  "myaccount_billing_details_city": "Ciudad",
  "myaccount_billing_details_country": "País",
  "myaccount_billing_details_description": "Cambie los datos de su cuenta y la dirección de facturación.",
  "myaccount_billing_details_details": "Datos de facturación",
  "myaccount_billing_details_email": "Email",
  "myaccount_billing_details_fistname": "Nombre",
  "myaccount_billing_details_lastname": "Apellido",
  "myaccount_billing_details_marketing": "Quiero recibir ofertas y consejos de turboSMTP",
  "myaccount_billing_details_phone_number": "Teléfono",
  "myaccount_billing_details_policy": "He leído y acepto la Política de Privacidad y los Términos y Condiciones",
  "myaccount_billing_details_state": "Estado/Región",
  "myaccount_billing_details_zip": "Código Postal",
  "myaccount_billing_slides_description": "Aquí puede encontrar las 'Facturas pro forma' relacionadas a su cuenta.",
  "myaccount_billing_slides_nodata": "No se encontraron facturas pro forma",
  "myaccount_billingcontacts_added": "Contacto de facturación agregado con éxito",
  "myaccount_billingcontacts_deleted": "Contacto de facturación eliminado con éxito",
  "myaccount_billingcontacts_edited": "Contacto de facturación editado con éxito",
  "myaccount_billingdetails_updated": "Se han actualizado los datos de facturación.",
  "myaccount_change_password": "Cambiar contraseña",
  "myaccount_confirm_delete_selectedcontact_label": "Confirmar acción",
  "myaccount_confirm_delete_selectedcontact_text": "¿Realmente desea eliminar este contacto?",
  "myaccount_confirm_password": "Confirmar contraseña",
  "myaccount_current_password": "Verificar contraseña actual",
  "myaccount_delimiter_change": "Cambiar delimitador de exportación CSV",
  "myaccount_delimiter_select": "Seleccionar delimitador",
  "myaccount_language": "Idioma de Visualización",
  "myaccount_language_change": "Cambiar idioma",
  "myaccount_language_description": "TurboSMTP ahora está disponible en Inglés e Italiano y Español. (Francés, Alemán, Hebreo, Portugués, Ruso y Árabe estarán disponibles próximamente).",
  "myaccount_language_select": "Seleccionar idioma",
  "myaccount_localization": "Localización",
  "myaccount_localization_description": "Cambiar idioma o delimitador de exportación CSV.",
  "myaccount_messages": "Mensajes del Sistema",
  "myaccount_messages_nomessages": "No se recibieron mensajes",
  "myaccount_messages_nomessages_description": "En esta sección encontrarás los mensajes que nuestro sistema ha enviado a tu cuenta.",
  "myaccount_new_password": "Nueva Contraseña",
  "myaccount_password_changed": "La contraseña fue cambiada exitosamente",
  "myaccount_password_choose": "Elija su nueva contraseña",
  "myaccount_password_notmatch": "Las contraseñas no coinciden. Intente nuevamente.",
  "myaccount_password_suggestions": "Las contraseñas deben contener al menos 10 caracteres, incluidas letras mayúsculas, minúsculas y al menos un número.",
  "myaccount_product_delete_label": "Confirmar acción",
  "myaccount_product_delete_text": "¿Está seguro de querer cancelar este producto?",
  "myaccount_product_deleted": "La solicitud de cancelación se ha enviado con éxito.",
  "myaccount_products": "Mis Productos",
  "myaccount_products_billingcycle": "Ciclo de facturación",
  "myaccount_products_cycle_annually": "Anualmente",
  "myaccount_products_cycle_biennally": "Bienalmente",
  "myaccount_products_cycle_free_account": "Cuenta Gratuita",
  "myaccount_products_cycle_month": "Mensualmente",
  "myaccount_products_cycle_monthly": "Mensualmente",
  "myaccount_products_cycle_one_time": "Único Pago",
  "myaccount_products_cycle_onetime": "Único Pago",
  "myaccount_products_cycle_quarterly": "Trimestralmente",
  "myaccount_products_cycle_semi-annually": "Semestralmente",
  "myaccount_products_cycle_triennially": "Trienalmente",
  "myaccount_products_cycle_year": "Anual",
  "myaccount_products_cycle_yearly": "Anual",
  "myaccount_products_fistpayment": "Monto del primer pago",
  "myaccount_products_nextduedate": "Próxima Fecha de Expiración",
  "myaccount_products_noproduct": "No hay productos",
  "myaccount_products_noproduct_description": "En esta sección encontrarás los productos y servicios asociados a la cuenta.",
  "myaccount_products_payment": "Método de Pago",
  "myaccount_products_price": "Precio",
  "myaccount_products_productservice": "Producto/Servicio",
  "myaccount_products_recurringamount": "Monto Recurrente",
  "myaccount_products_registration": "Fecha de Registro",
  "myaccount_products_slide_productservice_description": "Administre su producto directamente desde esta área.",
  "myaccount_products_status": "Estado",
  "plans_addon_options_title": "Planes complementarios",
  "plans_available_recurring_options_title": "Planes Disponibles",
  "plans_billing_cycle": "Ciclo de facturación",
  "plans_current_plans_title": "Sus planes actuales",
  "plans_cycle_month": "Mensual",
  "plans_cycle_monthly": "Mensual",
  "plans_cycle_onetime": "Única vez",
  "plans_cycle_year": "Anual",
  "plans_cycle_yearly": "Anual",
  "plans_downgrade_options_title": "Opciones de downgrade",
  "plans_feature_dedicated_ip": "IP dedicada",
  "plans_feature_email_credits": "Créditos de email",
  "plans_feature_smtp_limit": "Límite SMTP",
  "plans_features": "Características",
  "plans_invoice_created": "La factura se ha creado correctamente.",
  "plans_invoice_error": "No se pudo crear la factura. Inténtelo de nuevo.",
  "plans_load_error": "No se pudieron cargar las opciones del plan. Inténtelo de nuevo.",
  "plans_onetime_options_title": "Planes de única vez",
  "plans_plan_name": "Nombre del plan",
  "plans_plan_type": "Tipo de plan",
  "plans_select_plan": "Seleccionar plan",
  "plans_type_addon": "Complemento",
  "plans_type_onetime": "Única vez",
  "plans_type_recurring": "Recurrente",
  "plans_upgrade_options_title": "Opciones de upgrade",
  "myaccount_sentdate": "Fecha de Envío",
  "new_dashboard_error": "Lo sentimos, ocurrió un error:",
  "new_dashboard_if_you_think": "Si cree que está viendo este mensaje por error, por favor vaya a <a href=\"https://serversmtp.com/es/contactenos/\" target=\"_blank\" >para contactarnos</a>.",
  "new_dashboard_not_allowed": "Contacte a nuestro <a href='https://serversmtp.com/contact-us/' target='_blank'>Equipo de Soporte</a> para comenzar a utilizar la versión Beta del Panel.",
  "new_dashboard_token_valid": "El token es válido",
  "new_dashboard_token_wrong": "El token es incorrecto",
  "new_dashboard_validating": "Validando token...",
  "no": "No",
  "no_parameters_was_provided_for_update": "No se proporcionó ningún parámetro para la actualización.",
  "no_suppression_data_were_provided": "No se proporcionaron datos de anulación.",
  "noFilter": "Sin Filtro",
  "notContains": "No contiene",
  "notEquals": "No es igual",
  "one_time": "Una vez",
  "optional": "Opcional",
  "or": "o",
  "password_is_invalid": "Ninguna cuenta coincide con esa contraseña",
  "password_is_missing": "Falta la contraseña",
  "password_length_should_not_be_less_than_10_characters": "La contraseña debe contener al menos 10 caracteres",
  "password_should_contain_at_least_one_uppercase_character": "La contraseña debe contener al menos 1 carácter mayúscula",
  "password_should_contain_at_least_one_lowercase_character": "La contraseña debe contener al menos 1 carácter minúscula",
  "password_should_contain_at_least_one_digit": "La contraseña debe contener al menos 1 dígito",
  "password_should_equals_to_confirm_password": "La contraseña y la confirmación deben coincidir",
  "plan": "plan",
  "plan_daily": "Plan Diario",
  "plan_desc": "{order}. {smtp_limit_interval} {planT} ({smtp_limit} / {limit_unit})",
  "plan_desc_small": "{smtp_limit} emails / {limit_unit}",
  "plan_monthly": "Plan Mensual",
  "plan_short_daily": "día",
  "plan_short_monthly": "mes",
  "plan_short_yearly": "año",
  "plan_yearly": "Plan Anual",
  "primeng": {
    "accept": "Sí",
    "addRule": "Agregar regla",
    "after": "Después",
    "apply": "Aplicar",
    "before": "Antes",
    "cancel": "Cancelar",
    "choose": "Elegir",
    "clear": "claro",
    "contains": "Contiene",
    "dateAfter": "La fecha es posterior a",
    "dateBefore": "La fecha es anterior a",
    "dateFormat": "dd/mm/aa",
    "dateIs": "La fecha es",
    "dateIsNot": "La fecha no es",
    "dayNames": [
      "Domingo",
      "Lunes",
      "Martes",
      "Miû?rcoles",
      "Jueves",
      "Viernes",
      "SûÀbado"
    ],
    "dayNamesMin": [
      "D",
      "L",
      "M",
      "X",
      "J",
      "V",
      "S"
    ],
    "dayNamesShort": [
      "Dom",
      "Lun",
      "Mar",
      "Miû?",
      "Jue",
      "Vie",
      "SûÀb"
    ],
    "emptyFilterMessage": "No se encontraron resultados",
    "emptyMessage": "No se encontraron resultados",
    "endsWith": "Termina en",
    "equals": "igual a",
    "firstDayOfWeek": 1,
    "gt": "Mayor que",
    "gte": "Mayor o igual que",
    "is": "es",
    "isNot": "No es",
    "lt": "Menor que",
    "lte": "Menor o igual que",
    "max_limit_reached": "Has alcanzado el número máximo de subcuentas activables en tu plan actual.",
    "matchAll": "Coincidir con todo",
    "matchAny": "Coincidir con Cualquiera",
    "medium": "Medio",
    "monthNames": [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Mes de julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    "monthNamesShort": [
      "En",
      "Febr",
      "Mzo",
      "Abr",
      "My",
      "Jun",
      "Jul",
      "Agto",
      "Set",
      "Oct",
      "Nov",
      "Dic"
    ],
    "noFilter": "Sin filtro",
    "notContains": "No contiene",
    "notEquals": "No es igual a",
    "passwordPrompt": "Ingrese una contraseña",
    "reject": "No",
    "removeRule": "Eliminar regla",
    "startsWith": "Comienza con",
    "strong": "Fuerte",
    "today": "Hoy",
    "upload": "Subir",
    "weak": "Débil",
    "weekHeader": "Wk"
  },
  "reject": "No",
  "removeRule": "Eliminar Regla",
  "return_toaddons": "Regresar a addons",
  "saturday": "Sábado",
  "server_error_please_try_again": "Error del Servidor. Por favor, inténtelo de nuevo más tarde.",
  "server_error_while_performing_update": "Se produjo un error del servidor al realizar la actualización",
  "server_problem_gateway_timeout": "Se agotó el tiempo de espera de la puerta de enlace con el servidor. Por favor vuelva a intentarlo.",
  "server_problem_please_retry": "Problema con el servidor, por favor vuelva a intentarlo.",
  "server_problem_unknown_error": "Error de servidor desconocido, por favor vuelva a intentarlo.",
  "settings_activities_description": " Reciba informes de la actividad de sucuenta en su bandeja de entrada. Los informes pueden ser diarios, semanales y/o mensuales, y cubren todas las actividades de su cuenta.",
  "settings_activities_slide_dailyreport": "Reporte Diario",
  "settings_activities_slide_day": "Día",
  "settings_activities_slide_dayoftheweek": "Día de la semana",
  "settings_activities_slide_description": "Puede recibir informes diarios, semanales y mensuales de todas las actividades de su cuenta. Su informe será enviado a su dirección de correo electrónico registrada.",
  "settings_activities_slide_monthlyreport": "Reporte Mensual",
  "settings_activities_slide_time": "Hora",
  "settings_activities_slide_title": "Informes de actividad",
  "settings_activities_slide_weeklyreport": "Reporte Semanal",
  "settings_activities_title": "Informes de actividad",
  "settings_alert_usage_limit": "Límite de uso",
  "settings_alerts_description": "Reciba una alerta por correo electrónico cuando haya utilizado un porcentaje específico de sus créditos de envío.",
  "settings_alerts_slide_add": "Agregar una Alerta",
  "settings_alerts_slide_description": "Para evitar quedarse sin saldo de envío en medio de una campaña, reciba una alerta por correo electrónico cuando alcance un porcentaje determinado de sus créditos. Le sugerimos activar la alerta al 80% de su crédito disponible.",
  "settings_alerts_slide_empty_description": "Configure una alerta que se enviará a su dirección de correo electrónico cuando alcance un porcentaje determinado de sus créditos.",
  "settings_alerts_slide_empty_title": "Agregar una Alerta",
  "settings_alerts_slide_frequency": "Frecuencia",
  "settings_alerts_slide_percentage": "Porcentaje",
  "settings_alerts_slide_placeholder": "ej. nombre@direccion.com",
  "settings_alerts_slide_sendto": "Enviar a",
  "settings_alerts_slide_title": "Alertas",
  "settings_alerts_slide_type": "Tipo de Alerta",
  "settings_alerts_title": "Alertas",
  "settings_api_description": "Envíe sus correos electrónicos directamente desde su sitio web o cualquier aplicación con la API de turboSMTP.",
  "settings_api_title": "Documentación de la API",
  "settings_bccs_description": "Cada dirección que se encuentre en la lista CCO recibirá una copia de todos los correos que envíe, sin que el destinatario vea los datos de los otros destinatarios.",
  "settings_bccs_enable": "Habilitar para autorizar una cuenta de correo electrónico para recibir una copia de cualquier correo electrónico enviado.",
  "settings_bccs_slide_add": "Agregar CCO's",
  "settings_bccs_slide_description": "Por favor configure y autorice una o más cuentas de correo electrónico para que reciban una copia de cualquiera de sus emails enviados.",
  "settings_bccs_slide_email": "Email",
  "settings_bccs_slide_empty": "Por favor configure una cuenta de correo electrónico y autorícela para recibir una copia de cualquier correo electrónico enviado.",
  "settings_bccs_slide_empty_title": "Agregar una dirección CCO",
  "settings_bccs_slide_name": "Nombre",
  "settings_bccs_slide_not_verified": "No verificado",
  "settings_bccs_slide_status": "Estado",
  "settings_bccs_slide_title": "CCO (Con Copia Oculta)",
  "settings_bccs_slide_verified": "Verificado",
  "settings_bccs_title": "CCO (Con Copia Oculta)",
  "settings_bounces_description": "Habilitar las Notificaciones de Devoluciones hace que se envíen las notificaciones sobre sus correos rebotados a nosotros. Para recibir las notificaciones de rebote usted mismo, deshabilite esta opción.",
  "settings_bounces_title": "Administración de Rebotes",
  "settings_click_tracking": "Seguimiento de Clics",
  "settings_click_tracking_description": "El Seguimiento de Clics registra todos los clics realizados en cada enlace de sus correos electrónicos enviados.",
  "settings_dns_bar_description": "Ambos registros, SPF y DKIM deben agregarse a todos los dominios de remitente que usted use",
  "settings_dns_bar_dkim_description": " Un registro DKIM se puede agregar como un registro TXT insertando lo siguiente:",
  "settings_dns_bar_dkim_title": "Registros DKIM",
  "settings_dns_bar_domainaut": "Autenticación de Dominio",
  "settings_dns_bar_domainaut_description": "Permita que TurboSMTP envíe emails en su nombre.",
  "settings_dns_bar_domainaut_is": "The 'Domain Authentication' mode is:",
  "settings_dns_bar_spf_description": "Agregue el siguiente registro TXT en el dominio de la dirección de envío (ejemplo.com), use uno de los siguientes dos casos:",
  "settings_dns_bar_spf_description_a": "<strong>Si ya existe un registro SPF en la configuración DNS de su dominio</strong>, necesitará modificarlo. Simplemente agregue",
  "settings_dns_bar_spf_description_b": "directamente después del segmento",
  "settings_dns_bar_spf_description_c": "Recuerde dejar un espacio antes y después de esta adición para mantener la sintaxis adecuada.",
  "settings_dns_bar_spf_description_d": "<strong>Si no cuenta con un registro SPF existente</strong>, proceda a establecer uno ingresando la información necesaria en un nuevo registro TXT dentro de la configuración DNS de su dominio (no es necesario especificar un Dominio SPF a menos que se requiera):  ",
  "settings_dns_bar_spf_title": "Registro SPF",
  "settings_dns_bar_title": "Configuraciones DNS",
  "settings_dns_description": "Agregue nuestros registros DNS a su dominio de envío para firmar sus correos electrónicos con DKIM y garantizar una capacidad de entrega óptima.",
  "settings_dns_title": "Registros DNS",
  "settings_email_body_tip": "Por favor especifique <% body %> en su entrada.",
  "settings_email_elements": "Elementos del Email",
  "settings_email_footers_added": "Pie de página añadido con éxito",
  "settings_email_footers_confirm_delete_label": "Confirmar acción",
  "settings_email_footers_confirm_delete_text": "¿Realmente desea eliminar este pie de página?",
  "settings_email_footers_default": "La configuración del pie de página se actualizó correctamente",
  "settings_email_footers_removed": "Pie de página eliminado con éxito",
  "settings_email_footers_updated": "Pie de página actualizado con éxito",
  "settings_email_name_tip": "Por favor especifique un nombre",
  "settings_email_templates_added": "Plantilla añadida con éxito",
  "settings_email_templates_confirm_delete_label": "Confirmar acción",
  "settings_email_templates_confirm_delete_text": "¿Realmente desea eliminar esta plantilla?",
  "settings_email_templates_default": "La configuración de las plantillas se actualizó correctamente",
  "settings_email_templates_removed": "Plantilla eliminada con éxito",
  "settings_email_templates_updated": "Plantilla actualizada correctamente",
  "settings_email_unsub_added": "Link de desuscripción añadido con éxito",
  "settings_email_unsub_confirm_delete_label": "Confirmar acción",
  "settings_email_unsub_confirm_delete_text": "¿Realmente desea eliminar este link de desuscripción?",
  "settings_email_unsub_removed": "Link de desuscripción eliminado con éxito",
  "settings_email_unsub_updated": "Link de desuscripción actualizado con éxito",
  "settings_footers_description": "Agregue un pie de página a sus correos",
  "settings_footers_slide_add": "Añadir pie de página",
  "settings_footers_slide_convert": "HTML a Texto",
  "settings_footers_slide_default": "Predeterminado",
  "settings_footers_slide_description": "Haga clic en \"Añadir pie de página\" o edite un pie de página existente, luego ingrese el nombre del pie de página y complete los campos usando HTML o texto sin formato.",
  "settings_footers_slide_empty_description": "Haga clic en \"Añadir pie de página\" o edite un pie de página existente, luego ingrese el nombre del pie de página y complete los campos usando HTML o texto sin formato.",
  "settings_footers_slide_empty_title": "No hay pies de página",
  "settings_footers_slide_htmltext": "Texto HTML",
  "settings_footers_slide_name": "Nombre",
  "settings_footers_slide_plaintext": "Texto sin formato",
  "settings_footers_slide_title": "Pies de página",
  "settings_footers_title": "Pies de página",
  "settings_ga_bar_description": "Por favor complete los siguientes campos, incluyendo el nombre y la fuente de los datos de su campaña, para activar la integración con Google Analytics.",
  "settings_ga_bar_title": "Google Analytics",
  "settings_ga_content": "Contenido de la Campaña",
  "settings_ga_content_mandatory": "El Contenido de la Campaña es obligatorio",
  "settings_ga_integrate": "Integre Google Analytics para rastrear sus tasas de conversión y otros datos",
  "settings_ga_medium": "Medio de la Campaña",
  "settings_ga_medium_mandatory": "El Medio de la Campaña es obligatorio",
  "settings_ga_name": "Nombre de la Campaña",
  "settings_ga_name_mandatory": "El Nombre de la Campaña es obligatorio",
  "settings_ga_parameters": "Parámetros",
  "settings_ga_parameters_description": "Por favor complete los siguientes campos, incluido el nombre y la fuente de los datos de su campaña, para activar su integración con Google Analytics.",
  "settings_ga_source": "Fuente de la Campaña",
  "settings_ga_source_mandatory": "La Fuente de la Campaña es obligatoria",
  "settings_ga_term": "Término de la Campaña",
  "settings_ga_term_mandatory": "El Término de la Campaña es Obligatorio",
  "settings_google_analytics_description": "Google Analytics rastrea sus tasas de conversión y otros datos.",
  "settings_google_analytics_title": "Google Analytics",
  "settings_integrations": "Integraciones",
  "settings_integrations_authentication_disabled": "El modo 'Autenticación de dominio' es: Desactivado",
  "settings_integrations_authentication_enabled": "El modo 'Autenticación de dominio' es: Activado",
  "settings_integrations_dkim_updated": "La configuración de DKIM se actualizó correctamente",
  "settings_notification_alert_confirm_delete_label": "Confirmar acción",
  "settings_notification_alert_confirm_delete_text": "¿Realmente desea eliminar esta alerta?",
  "settings_notification_bcc_confirm_delete_label": "Confirmar acción",
  "settings_notification_bcc_confirm_delete_success": "El CCO {email} se eliminó correctamente.",
  "settings_notification_bcc_confirm_delete_text": "¿Realmente desea eliminar la dirección CCO {email}?",
  "settings_notification_smtp_auth": "Autenticación SMTP",
  "settings_notifications": "Notificaciones",
  "settings_notifications_alert_added": "La alerta ha sido creada con éxito",
  "settings_notifications_alert_deleted": "La alerta se ha eliminado correctamente.",
  "settings_notifications_alert_updated": "La alerta ha sido actualizada con éxito",
  "settings_notifications_bcc_emailbox": "Acabamos de enviar un mensaje de verificación a <{email}>.",
  "settings_notifications_bcc_update_success": "El email CCO {email} se ha actualizado correctamente.",
  "settings_notifications_smtp_auth_enabled": "Activado",
  "settings_notifications_smtp_host": "pro.turbo-smtp.com",
  "settings_notifications_smtp_host_eu": "pro.eu.turbo-smtp.com",
  "settings_notifications_smtp_passvalue": "*********<br>(la contraseña que usas para entrar a este panel de control)",
  "settings_notifications_smtp_password": "Contraseña SMTP",
  "settings_notifications_smtp_ports": "Puertos SMTP",
  "settings_notifications_smtp_server": "Servidor SMTP",
  "settings_notifications_smtp_username": "Nombre de usuario SMTP",
  "settings_open_tracking": "Seguimiento de Aperturas",
  "settings_open_tracking_description": "Habilitar el seguimiento de aperturas creará un registro de sus mensajes abiertos, lo que le permitirá realizar un mejor seguimiento de los resultados de la campaña.",
  "settings_setting_changed": "Configuración cambiada {service}",
  "settings_setting_disabled": "Configuración desactivada {service}",
  "settings_setting_enabled": "Configuración activada {service}",
  "settings_setting_notdisabled": "Configuración {service} no puede ser activada.",
  "settings_setting_notenabled": "Configuración {service} no puede ser activada.",
  "settings_setting_webhook_notenabled": "Los web-hooks de notificación de eventos están disponibles solo en los planes PRO.",
  "settings_smtp_description": "Para conectarse vía SMTP, configure el SMTP en su cliente de correo o en cualquier otra aplicación de correo agregando los siguientes parámetros. Haga clic en el botón \"Más\" para ver las configuraciones.",
  "settings_smtp_slide_description": "Configure el SMTP en su cliente de correo, o en cualquier otra aplicación de correo, agregando los siguientes parámetros.",
  "settings_smtp_slide_description_api": "El nombre de usuario y la contraseña de autenticación SMTP son un par de claves API: use el Consumer Key como nombre de usuario SMTP y el Consumer Secret como contraseña SMTP. Trátelos como credenciales que deben mantenerse secretas y rotarse si es necesario.",
  "settings_smtp_slide_parameter": "Parámetro",
  "settings_smtp_slide_title": "Conectando vía SMTP",
  "settings_smtp_slide_value": "Valor",
  "settings_smtp_title": "Conectando vía SMTP",
  "settings_template_description": "Las plantillas son la herramienta perfecta para darle un toque profesional a la apariencia de su correo.",
  "settings_template_slide_add": "Agregar plantilla",
  "settings_template_slide_default": "Predeterminado",
  "settings_template_slide_description": "Haga clic en \"Agregar plantilla\" y complete los campos con la información requerida, incluido el nombre de la plantilla y HTML o texto sin formato.",
  "settings_template_slide_empty_description": "Haga clic en \"Agregar plantilla\" y complete los campos con la información requerida, incluido el nombre de la plantilla y HTML o texto sin formato.",
  "settings_template_slide_empty_title": "Agregar plantilla",
  "settings_template_slide_html": "Versión HTML",
  "settings_template_slide_info": "<% body %> es obligatorio en el texto HTML y el texto sin formato. Y será reemplazado con el contenido real.",
  "settings_template_slide_name": "Nombre de la plantilla",
  "settings_template_slide_plaintext": "Versión de texto sin formato",
  "settings_template_slide_title": "Plantillas",
  "settings_template_title": "Plantillas",
  "settings_title": "Configuraciones",
  "settings_tracking": "Seguimiento",
  "settings_unsubscribe_description": "Agregue un link de desuscripción en la parte inferior de sus correos de texto sin formato o HTML. No se enviarán emails a los usuarios que estén desuscritos.",
  "settings_unsubscribe_select": "Seleccione un idioma",
  "settings_unsubscribe_slide_add": "Agregar link de desuscripción",
  "settings_unsubscribe_slide_description": "Agregue un link de desuscripción en la parte inferior de sus correos de texto sin formato y HTML. No se enviarán correos electrónicos a los usuarios que no estén suscritos. Las desuscripciones se manejarán automáticamente y en tiempo real para mejorar su reputación de correo. Ingrese el texto que desea usar (como \"Para darse de baja, haga clic aquí\") y luego pegue el texto en su mensaje.",
  "settings_unsubscribe_slide_empty": "Agregar un link de desuscripción",
  "settings_unsubscribe_slide_empty_description": "Agregue un link de desuscripción en la parte inferior de sus correos de texto sin formato y HTML. No se enviarán correos electrónicos a los usuarios que no estén suscritos. Las desuscripciones se manejarán automáticamente y en tiempo real para mejorar su reputación de correo. Ingrese el texto que desea usar (como \"Para darse de baja, haga clic aquí\") y luego pegue el texto en su mensaje.",
  "settings_unsubscribe_slide_language": "Seleccione un idioma",
  "settings_unsubscribe_slide_placeholder": "Etiqueta",
  "settings_unsubscribe_slide_text": "Texto de Desuscripción",
  "settings_unsubscribe_slide_title": "Link de Desuscripción",
  "settings_unsubscribe_text": "Texto",
  "settings_unsubscribe_title": "Link de Desuscripción",
  "settings_unsubscribe_value": "Ej. Para desuscribirse, haga clic aquí",
  "settings_webhooks_description": "Los webhooks permiten que su aplicación web reciba notificaciones de entrega de los correos y eventos de interacción.",
  "settings_webhooks_slide_alert": "Los cambios aplicados pueden tardar hasta 1 hora para tomar efecto.",
  "settings_webhooks_slide_bounced": "Rebotes",
  "settings_webhooks_slide_click": "Clics",
  "settings_webhooks_slide_deferred": "Demorados",
  "settings_webhooks_slide_delivered": "Entregados",
  "settings_webhooks_slide_deliveryevents": "Eventos de Entrega",
  "settings_webhooks_slide_description": "Puede usar webhooks de notificación de eventos para recibir notificaciones de eventos que ocurren en sus campañas sin tener que usar las API.",
  "settings_webhooks_slide_dropped": "Rechazados",
  "settings_webhooks_slide_engagementevents": "Eventos de Engagement",
  "settings_webhooks_slide_inserturl": "Inserte aquí la url en la que desea ser notificado",
  "settings_webhooks_slide_notification": "URL de notificación de webhook",
  "settings_webhooks_slide_notification_description": "Habilitar notificaciones de webhook",
  "settings_webhooks_slide_open": "Apertura",
  "settings_webhooks_slide_placeholder": "https://",
  "settings_webhooks_slide_processed": "Procesado",
  "settings_webhooks_slide_spamreport": "Reporte de spam",
  "settings_webhooks_slide_title": "Webhooks",
  "settings_webhooks_slide_unsubscribe": "Desuscripción",
  "settings_webhooks_support": "Por favor contacte a nuestro soporte y solicite la 'Activación de eventos de entrega'.",
  "settings_webhooks_title": "Webhooks",
  "settings_webhooks_upgrade": "Actualizar a plan Profesional",
  "startsWith": "Inicia con",
  "subaccount_policy_agree": "He leído y aceptado los <a href=\"https://serversmtp.com/es/es_terms-and-conditions/\" target=\"_blank\">términos de servicio</a> y la<a href=\"https://serversmtp.com/es/politica-de-privacidad-regulacion-ue-2016-79-gdpr/\" target=\"_blank\">política de privacidad</a>",
  "subaccount_policy_agree_notchecked": "Debe aceptar los términos de servicio y la política de privacidad.",
  "subaccount_slide_inuse": "En uso",
  "subaccount_slide_ip": "IP",
  "subaccount_slide_ips": "IP's",
  "subaccount_slide_ips_description": "Por favor, seleccione una IP a asignar a esta subcuenta.",
  "subaccounts_action_activated": "{email} ha sido activado con éxito",
  "subaccounts_action_active": "Activo",
  "subaccounts_action_deactivated": "{email} ha sido suspendido con éxito",
  "subaccounts_action_delete": "Eliminar",
  "subaccounts_action_deleted": "Subcuenta eliminada con éxito",
  "subaccounts_action_details": "Detalles",
  "subaccounts_action_edit": "Editar",
  "subaccounts_action_limit": "Definir límites",
  "subaccounts_action_login": "Ingresar",
  "subaccounts_action_notdeleted": "Error al eliminar la subcuenta",
  "subaccounts_action_suspend": "Suspender",
  "subaccounts_active": "Activo",
  "subaccounts_added_succesfully": "La subcuenta fue agregada con éxito",
  "subaccounts_agencysettings": "Configuraciones de Agencia",
  "subaccounts_assigned_ip": "IP Asignada",
  "subaccounts_changed_succesfully": "La subcuenta ha sido modificada con éxito",
  "subaccounts_confirm_activation_label": "Confirmar activación",
  "subaccounts_confirm_activation_text": "¿Desea activar {email}?",
  "subaccounts_confirm_deactivation_label": "Confirmar desactivación",
  "subaccounts_confirm_deactivation_text": "¿Desea suspender la subcuenta: {email}?",
  "subaccounts_confirm_delete_label": "Confirmar eliminación",
  "subaccounts_confirm_delete_text": "¿Desea eliminar la subcuenta {email}?",
  "subaccounts_confirm_login_label": "Confirmar inicio de sesión",
  "subaccounts_confirm_login_text": "¿Está seguro que desea cerrar sesión en la cuenta actual e iniciar sesión en {email}?",
  "subaccounts_confirmation": "Confirmación",
  "subaccounts_create_warning": "La creación de nuevas subcuentas solo está disponible en los planes Profesionales",
  "subaccounts_email": "Cuenta de email",
  "subaccounts_empty": "Amplíe su negocio y ofrezca a sus clientes un servicio profesional totalmente personalizable con su marca, o divida sus créditos de envío entre sus empleados y colegas.<br>Una sencilla interfaz de administración que le permitirá monitorear el tráfico y las estadísticas.",
  "subaccounts_expiration_date": "Fecha de expiración",
  "subaccounts_inactive": "Inactivo",
  "subaccounts_ip": "IP",
  "subaccounts_last_activity": "Última actividad",
  "subaccounts_limits_nolimits": "Sin límite",
  "subaccounts_limits_sending": "Límite de envío:",
  "subaccounts_limits_slide_description": "Añada un límite para su subcuenta",
  "subaccounts_limits_slide_limits": "Límites",
  "subaccounts_limits_slide_noplan_expiration": "Sin expiración",
  "subaccounts_limits_slide_plan_expiration": "Expiración del plan",
  "subaccounts_limits_slide_set_plan_expiration": "Añadir expiración al plan",
  "subaccounts_limits_slide_this_number": "Este número se refiere a un período",
  "subaccounts_limits_slide_title": "Límites de Subcuenta",
  "subaccounts_no_expiration": "({master_expiration_date}) <i class=\"pi pi-info-circle\"></i>",
  "subaccounts_no_expiration_tooltip": "Conforme al vencimiento del plan de su cuenta principal",
  "subaccounts_settings_update": "Las configuraciones de la subcuenta se actualizaron ahora.",
  "subaccounts_slide_account_confirm": "Confirmar datos de la cuenta",
  "subaccounts_slide_account_description": "Haga clic en el botón Editar para cambiar la información de usuario de su subcuenta.",
  "subaccounts_slide_account_info": "Información de la cuenta",
  "subaccounts_slide_address": "Dirección",
  "subaccounts_slide_address2": "Dirección 2",
  "subaccounts_slide_change_password": "Añada una contraseña",
  "subaccounts_slide_city": "Ciudad",
  "subaccounts_slide_company": "Nombre de la empresa",
  "subaccounts_slide_confirm_password": "Confirmar contraseña",
  "subaccounts_slide_confirmpassword_different": "Por favor, asegúrese de que sus contraseñas coincidan.",
  "subaccounts_slide_country": "País",
  "subaccounts_slide_email": "Email",
  "subaccounts_slide_email_not_unique": "Esta dirección de correo electrónico ya se está utilizando.",
  "subaccounts_slide_email_required": "Se requiere una dirección de correo electrónico.",
  "subaccounts_slide_first_name": "Nombre",
  "subaccounts_slide_firstname_required": "El nombre es obligatorio",
  "subaccounts_slide_last_name": "Apellido",
  "subaccounts_slide_lastname_required": "El apellido es obligatorio",
  "subaccounts_slide_password": "Contraseña",
  "subaccounts_slide_password_details": "Deje el campo de contraseña en blanco para continuar usando su contraseña actual.",
  "subaccounts_slide_password_minlength": "La longitud de la contraseña debe ser al menos {req}. Actualmente es: {act}.",
  "subaccounts_slide_password_required": "La contraseña es requerida",
  "subaccounts_slide_password_pattern": "La contraseña debe contener al menos 10 caracteres, de los cuales al menos uno mayúscula, uno minúscula y uno dígito",
  "subaccounts_slide_phone": "Teléfono",
  "subaccounts_slide_profile_information": "Información del Perfil",
  "subaccounts_slide_region": "Estado/Región/Provincia",
  "subaccounts_slide_website": "Sitio Web",
  "subaccounts_slide_zip": "Código Postal",
  "subaccounts_status": "Estado",
  "subaccounts_subaccounts": "Listado de Subcuentas",
  "subaccounts_title": "Subcuentas",
  "subaccounts_unlimited": "Ilimitado <i class='pi pi-info-circle'></i>",
  "subaccounts_unlimited_tooltip": "Conforme al límite del plan de la cuenta principal.",
  "subaccounts_usage": "Uso",
  "sunday": "Domingo",
  "suppression_deleted": "Las anulaciones se eliminarán en breve.",
  "suppression_filters_reason": "Razón",
  "suppression_filters_recipient": "Destinatario",
  "suppression_filters_sender": "Remitente",
  "suppression_filters_sources": "Fuentes",
  "suppression_filters_subject": "Asunto del Email",
  "suppression_operators_exclude": "Excluir",
  "suppression_operators_include": "Incluir",
  "suppression_table_addcolumn_sender": "Remitente",
  "suppression_table_dropdown_text": "{first} — {last} of {totalRecords}",
  "suppression_types_bounce": "Rebote",
  "suppression_types_manual": "Manual",
  "suppression_types_spam": "Spam",
  "suppression_types_unsubscribe": "Desuscripción",
  "suppression_types_validation_failed": "La validación falló",
  "suppressions_add_form_errors": "Errores de formulario",
  "suppressions_add_form_nofile_selected": "Ningún archivo seleccionado",
  "suppressions_add_suppression": "Importar anulaciones",
  "suppressions_choose_columns": "Elegir columnas",
  "suppressions_confirm_delete_all_label": "Confirmar acción",
  "suppressions_confirm_delete_all_text": "¿Realmente desea eliminar todas las anulaciones entre<strong>{from}</strong> y <strong>{to}</strong>?",
  "suppressions_confirm_delete_all_type_text": "¿Realmente desea eliminar<br> todas <strong>{type}</strong> las anulaciones entre <strong>{from}</strong> y <strong>{to}</strong>?",
  "suppressions_confirm_delete_filtered_label": "Confirmar acción",
  "suppressions_confirm_delete_filtered_text": "¿Realmente desea eliminar todas las <strong>anulaciones filtradas</strong>? <br><small>*Las entradas por spam no se eliminarán</small>",
  "suppressions_confirm_delete_selected_label": "Confirmar acción",
  "suppressions_confirm_delete_selected_text": "¿Realmente desea eliminar las anulaciones seleccionadas?",
  "suppressions_date": "Fecha",
  "suppressions_delete_all": "Eliminar todo",
  "suppressions_delete_selected": "Eliminar seleccionados",
  "suppressions_deleted": "Las anulaciones se eliminarán en breve.",
  "suppressions_description_empty": "No se encontraron entradas en el período seleccionado.",
  "suppressions_details_date": "Fecha",
  "suppressions_details_entry": "Entrada",
  "suppressions_details_reason": "Motivo",
  "suppressions_details_sender": "Remitente",
  "suppressions_details_subject": "Asunto",
  "suppressions_details_title": "Detalles",
  "suppressions_details_type": "Tipo",
  "suppressions_imported": "Las anulaciones serán importadas en breve.",
  "suppressions_imported_partial": "{imported} / {total} anulaciones serán importadas en breve.",
  "suppressions_include": "Incluir",
  "suppressions_modal_confirm": "Confirmación",
  "suppressions_not_imported": "Las anulaciones no fueron importarán debido a correos electrónicos con formato incorrecto.",
  "suppressions_reason": "Motivo",
  "suppressions_recipient": "Destinatario",
  "suppressions_title": "Anulaciones",
  "suppressions_title_empty": "No se encontraron anulaciones",
  "suppressions_type": "Tipo",
  "t_api": "Documentación de la API",
  "t_knowledgebase": "Base de conocimiento",
  "t_logout": "Desconectarse",
  "table_dropdown_goto": "Ir a la página",
  "table_dropdown_text": "{first} — {last} de {totalRecords}",
  "thursday": "Jueves",
  "toggle_off": "Desactivado",
  "toggle_on": "Activado",
  "token_can_not_be_empty": "El token no puede estar vacío",
  "token_is_missing": "Hace falta el token",
  "tuesday": "Martes",
  "unlimited": "ilimitado",
  "upload": "Cargar",
  "upload_add_manually": "Agregar manualmente",
  "upload_add_manually_description": "Copie y pegue varias direcciones de correo en la sección de abajo, separélas con un espacio vacío. Para recordar por qué agregó estos contactos y ayudar en sus futuras búsquedas, agregue un motivo del porqué anula estas direcciones.",
  "upload_add_manually_placheholder": "email1,email2,email3,email4,email5...",
  "upload_add_reason": "Introduzca un motivo para anular estas direcciones.",
  "upload_allowed_files": "Los formatos soportados son csv o txt",
  "upload_dd_here": "Arrastre su archivo aquí",
  "upload_import_from_file": "Importar desde un archivo",
  "upload_import_from_file_description": "El archivo debe incluir sólo una columna que contenga todas las direcciones de correo que desea importar. Para recordar por qué agregó estos contactos y ayudar en sus futuras búsquedas, agregue un motivo del porqué anula estas direcciones.",
  "warning_lang": "El tablero en su idioma estará disponible pronto. Mientras tanto, comuníquese con el equipo de soporte para volver al anterior.",
  "wednesday": "Miércoles",
  "whitelabel_agencyname": "Nombre de la Agencia",
  "whitelabel_companydetails": "Datos de la empresa",
  "whitelabel_description": "Si ha creado una subcuenta y es un revendedor oficial de turboSMTP, puede personalizar el producto con su logotipo e información de su empresa, lo cual brindará a sus clientes un mejor experiencia de marca.",
  "whitelabel_footer": "Pie de página de la Agencia",
  "whitelabel_footer_description,": "Inserte el código HTML que se mostrará en el pie de página.",
  "whitelabel_logo": "Logo de la empresa",
  "whitelabel_logo_description": "Tamaño máximo permitido para la imagen: 472x72px",
  "whitelabel_reset_default_image": "Restaurar imagen predeterminada",
  "whitelabel_upload_image": "Subir imagen",
  "whitelabel_upload_in_progress": "Carga en progreso",
  "whitelabel_website": "Sitio web de la agencia",
  "wrong_credentials_specified": "Los datos de acceso son incorrectos",
  "yes": "Si",
  "missing_required_parameter_amount": "Por favor inserte la cantidad",
  "amount_should_be_integer": "La cantidad debe ser un número entero",
  "amount_should_not_be_less_than_15": "La cantidad no debe ser menor a 15",
  "amount_should_not_be_higher_than_1800": "La cantidad no debe ser más de 1800",
  "missing_settings_required": "Se requieren algunas configuraciones antes de habilitarlas",
  "settings_apikeys_title": "Claves API",
  "settings_apikeys_description": "Las claves API son una forma altamente segura de conectar los servicios de turboSMTP a sus aplicaciones. Puede revocar el acceso en cualquier momento.",
  "settings_apikeys_slide_title": "Claves API",
  "settings_apikeys_slide_description": "Administre sus claves API. Esta tabla muestra todas sus claves API activas. Puede crear nuevas claves o eliminar claves existentes para revocar su acceso.",
  "settings_apikeys_slide_empty_title": "Crear Clave API",
  "settings_apikeys_slide_empty_description": "Las claves API se componen de un Consumer Key y un Consumer Secret. Son credenciales de software que permiten que un programa acceda a su cuenta de turboSMTP sin utilizar su usuario y contraseña. Son altamente seguros y pueden revocarse en cualquier momento sin cambiar las credenciales de acceso al panel de turboSMTP.",
  "settings_apikeys_slide_add": "Crear Clave API",
  "settings_apikeys_slide_add_description": "Elija un nombre de referencia para su Clave API.",
  "settings_apikeys_apikey_name": "Nombre",
  "settings_apikeys_slide_label_info": "Este nombre es sólo para referencia. No necesitará ingresar el nombre en sus aplicaciones.",
  "settings_apikeys_apikey_key": "Consumer Key",
  "settings_apikeys_apikey_creationtime": "Fecha de creación",
  "settings_apikeys_apikey_name_label": "Nombre de la Clave API",
  "settings_apikeys_apikey_name_placeholder": "Ingrese el nombre de su Clave API",
  "settings_apikeys_apikey_edit_alt": "Editar Clave API",
  "settings_apikeys_apikey_revoke_alt": "Eliminar y revocar",
  "settings_apikeys_apikey_confirm_revoke_label": "Eliminar y revocar Clave API",
  "settings_apikeys_apikey_confirm_revoke_text": "¿Eliminar la Clave API \"{name}\"?<br>Esto revocará el acceso a todas las aplicaciones que utilicen esta clave.",
  "settings_apikeys_apikey_confirm_revoke_confirm": "Confirmar",
  "settings_apikeys_apikey_confirm_revoke_cancel": "Cancelar",
  "settings_apikeys_apikey_revoked": "Clave API revocada exitosamente",
  "settings_apikeys_apikey_consumerkey_button_add": "Generar Clave API",
  "settings_apikeys_apikey_consumerkey_button_save": "Guardar Cambios",
  "settings_apikeys_slide_edit_description": "Edita los detalles de la clave API a continuación.",
  "settings_apikeys_apikey_updated": "Clave API actualizada correctamente",
  "settings_apikeys_ips_label": "Restricción de IPs",
  "settings_apikeys_permissions_label": "Permisos API",
  "settings_apikeys_permissions_description": "Elige qué servicios puede acceder esta Clave API.",
  "settings_apikeys_permission_send_smtp": "Envío SMTP",
  "settings_apikeys_permission_send_api": "Envío HTTP API",
  "settings_apikeys_permission_apis": "Estadísticas y APIs de Gestión",
  "settings_apikeys_permissions_required": "Seleccione al menos una opción",
  "settings_apikeys_legacy_key_alert_message": "Hemos actualizado nuestra <strong>autenticación SMTP</strong> para usar <strong>claves API</strong> en lugar de la contraseña de su cuenta.<br>Para garantizar una transición sin problemas, <strong>hemos creado una clave API especial</strong> para usted que coincide con sus antiguas credenciales. Para una seguridad mejorada, le recomendamos encarecidamente que <strong>elimine esta clave y cree una nueva</strong> para usarla en su configuración SMTP.",
  "settings_apikeys_legacy_key_alert_link": "Más información",
  "settings_apikeys_legacy_key_alert_link_href": "https://serversmtp.com/es/actualizacion-de-seguridad-transicion-a-la-autenticacion-mediante-claves-api/",
  "settings_apikeys_apikey_new_success": "¡Clave API creada!",
  "settings_apikeys_apikey_consumer": "Consumer Key",
  "settings_apikeys_apikey_secret": "Consumer Secret",
  "settings_apikeys_apikey_new_security": "Este <strong>Consumer Secret</strong> sólo se muestra aquí. <strong>Cópielo ahora y guárdelo en un lugar seguro</strong>. Si pierde esta clave, deberá eliminarla y generar una nueva.",
  "settings_apikeys_restrict_ip_label": "Restringir clave API a IPs específicas",
  "settings_apikeys_restrict_ip_description": "Cuando esté habilitado, esta clave API solo funcionará desde las direcciones IP especificadas.",
  "settings_apikeys_allowed_ips_label": "Direcciones IP permitidas",
  "settings_apikeys_ip_placeholder": "Ingrese dirección IP (ej. 8.8.8.8)",
  "settings_apikeys_add_ip": "Agregar dirección IP",
  "settings_apikeys_remove_ip": "Eliminar dirección IP",
  "settings_apikeys_ip_required": "La dirección IP es requerida",
  "settings_apikeys_ip_invalid": "Ingrese una dirección IP válida",
  "settings_apikeys_allowed_ips": "IPs permitidas:",
  "settings_bccs_missing_required": "Asegúrese de establecer un BCC como predeterminado antes de habilitarlo",
  "settings_bccs_notifications_default": "El correo electrónico BCC predeterminado se actualizó correctamente",
  "settings_link_branding_enable": "Activar para usar su propio dominio de segumiento",
  "settings_link_branding_missing_required": "Agregue y verifique al menos un dominio antes de activar",
  "settings_link_branding_title": "Dominios de Seguimiento Personalizados",
  "settings_link_branding_description": "Use sus propios dominios para seguimiento de aperturas y clics en vez de los de turboSMTP",
  "settings_link_branding_box_alert": "Estas configuraciones no tendrán efecto si Seguimiento de Aperturas y Segimiento de Clics están desactivados. ",
  "settings_link_branding_empty_description": "Haga clic en \"Agregar dominio\" y complete los campos requeridos...",
  "settings_link_branding_empty_title": "Agregar Dominio de Seguimiento",
  "settings_link_branding_add_domain": "Agregar Dominio de Seguimiento",
  "settings_link_branding_add_domain_info": "Ingrese su dominio y edite algunas configuraciones adicionales.",
  "settings_link_branding_advanced": "Opciones avanzadas",
  "settings_link_branding_custom_subdomain": "Subdominio personalizado",
  "settings_link_branding_custom_subdomain_tooltip": "Por favor agregue un nombre de dominio válido antes de especificar un subdominio personalizado",
  "settings_link_branding_custom_subdomain_info": "El sistema generará un subdominio aleatorio. Si desea utilizar uno específico, ingréselo aquí.",
  "settings_link_branding_button_add": "Agregar Dominio de Seguimiento",
  "settings_link_branding_match": "Hacer que coincidan el dominio de seguimiento con el dominio del remitente",
  "settings_link_branding_match_sender_disabled": "Dominios coincidentes deshabilitados",
  "settings_link_branding_match_sender_enabled": "Dominios coincidentes habilitados",
  "settings_link_branding_filters_no_results": "No se encontraron entradas con estos filtros.",
  "settings_link_branding_search_placeholder": "Filtrar dominios de seguimiento por nombre...",
  "settings_link_branding_verification_placeholder": "Verificación...",
  "settings_link_branding_verified": "Verificado",
  "settings_link_branding_click_to_verify": "PENDIENTE. La configuración CNAME para este dominio no se ha completado ni verificado. Haga clic para continuar...",
  "settings_link_branding_verification_success": "Verificación exitosa",
  "settings_link_branding_verification_domain_not_found": "Dominio no encontrado",
  "settings_link_branding_verification_cname_not_found": "No se encontró el CNAME del subdominio {track_dns}",
  "settings_link_branding_verification_auth_cname_not_found": "No se encontró el CNAME del subdominio {auth_dns}",
  "settings_link_branding_verification_multiple_cname_found": "Se encontraron múltiples registros CNAME para el subdominio {track_dns}",
  "settings_link_branding_verification_auth_multiple_cname_found": "Se encontraron múltiples registros CNAME para el subdominio {auth_dns}",
  "settings_link_branding_verification_incorrect_cname_target": "El CNAME del subdominio {track_dns} tiene un valor incorrecto",
  "settings_link_branding_verification_auth_incorrect_cname_target": "El CNAME del subdominio {auth_dns} tiene un valor incorrecto",
  "settings_link_branding_enabled": "Activado",
  "settings_link_branding_disabled": "Desactivado",
  "settings_link_branding_not_verified": "Pendiente",
  "settings_link_branding_name": "Nombre del dominio",
  "settings_link_branding_enabled_no": "Dominio de seguimiento desactivado",
  "settings_link_branding_enabled_yes": "Dominio de seguimiento activado",
  "settings_link_branding_default_enabled": "Dominio de seguimiento configurado como No Dedicado",
  "settings_link_branding_default_disabled": "Dominio de seguimiento configurado como Dedicado",
  "settings_link_branding_subdomain_name_invalid": "El subdominio no es válido",
  "settings_link_branding_domain_name_invalid": "Nombre de dominio inválido",
  "settings_link_branding_confirm_delete_label": "Eliminar dominio de seguimiento",
  "settings_link_branding_confirm_delete_text": "¿Realmente desea eliminar este dominio de seguimiento?",
  "invalid_domain_name": "Nombre inválido de dominio",
  "settings_link_branding_exclusivity_placeholder": "Es dedicado...",
  "settings_link_branding_exclusive": "Dedicado",
  "settings_link_branding_not_exclusive": "No dedicado",
  "settings_link_branding_domain_name": "Dominio de Seguimiento",
  "settings_link_branding_domain_status": "Estado",
  "settings_link_branding_added": "Dominio agregado exitosamente",
  "settings_link_branding_removed": "Dominio eliminado exitosamente",
  "settings_link_branding_default_match_help": "Los dominios dedicados solo se usan con dominios de remitente que coinciden. Nunca se utilizan con dominios de remitente diferentes. ",
  "settings_link_branding_dns_info": "Deberá agregar los siguientes registros para completar el proceso.",
  "settings_link_branding_ssl_verify": "No podemos verificar si sus dominios SSL están configurados correctamente desde el panel de control. Si necesita ayuda, por favor póngase en contacto con nuestro equipo de soporte técnico.",
  "settings_link_branding_dns_wait": "Los cambios en los registros DNS pueden tomar hasta 24 horas en surtir efecto",
  "settings_link_branding_dns_info_host": "Por favor agregue estos dos registros a la sección DNS de su host.",
  "settings_link_branding_dns_type": "Tipo",
  "settings_link_branding_dns_host": "Host",
  "settings_link_branding_dns_host_help": "Algunos alojamientos DNS pueden referirse a esto como \"Dominio\" o \"Nombre\"",
  "settings_link_branding_dns_value": "Valor",
  "settings_link_branding_dns_value_help": "Algunos alojamientos DNS pueden referirse a esto como \"Datos\"",
  "settings_link_branding_dns_help": "¿No está seguro de cómo hacer esto?",
  "settings_link_branding_dns_help_link": "Consulte la documentación",
  "settings_link_branding_dns_verification_tooltip": "Este registro CNAME es el mismo para todos los subdominios del dominio. Debe agregarse solo una vez: si ya está presente, no es necesario agregarlo.",
  "settings_link_branding_verify_description": "Una vez agregado, presione Verificar.",
  "settings_link_branding_verify_button": "Verificar",
  "settings_link_branding_delete_info": "¿Ya no necesita este dominio de seguimiento?",
  "settings_link_branding_delete_button": "Eliminar dominio de seguimiento",
  "settings_link_branding_security_placeholder": "Seguridad...",
  "settings_link_branding_https": "HTTPS",
  "settings_link_branding_http": "HTTP",
  "settings_link_branding_button_ok": "Ok",
  "settings_link_branding_status_placeholder": "Estado...",
  "settings_link_branding_status_enabled_no": "Desactivado",
  "settings_link_branding_status_enabled_yes": "Activo",
  "settings_link_branding_all_domains_disabled": "Cuando todos los dominios personalizados estén deshabilitados o en estado pendiente, se utilizarán los dominios de seguimiento turboSMTP.",
  "settings_link_branding_no_default_domain": "Si configura todos los enlaces de seguimiento activos como dedicados, los remitentes con dominios deshabilitados o faltantes en esta lista utilizarán nuestros enlaces de seguimiento de turboSMTP.",
  "settings_link_branding_match_modal_cancel": "Cancelar",
  "settings_link_branding_match_modal_confirm": "Ok",
  "settings_link_branding_match_title": "Rotación de Dominio",
  "settings_link_branding_match_change": "Cambiar este comportamiento",
  "settings_link_branding_match_enabled_title": "Coincidir con el dominio del remitente",
  "settings_link_branding_match_disabled_title": "No necesita coincidir con el dominio del remitente",
  "settings_link_branding_match_enabled_info": "Si el dominio del remitente coincide con uno de los dominios de seguimiento activos, se utilizará ese dominio de seguimiento.<br> Si el dominio del remitente no coincide con ningún dominio de seguimiento, uno de los dominios de seguimiento activos (excluyendo los \"Dedicados\" ) será usado aleatoriamente.",
  "settings_link_branding_match_disabled_info": "Se usarán todos los dominios de seguimiento activos, independientemente del dominio del remitente.",
  "config_server_error": "El panel de control está en mantenimiento, inténtelo de nuevo en unos minutos",
  "feature_not_available_for_active_plan": "Esta función no está incluida en ninguno de tus planes",
  "forgot_password_use_different_password": "Por favor, crea una nueva contraseña que sea diferente a las anteriores para aumentar la seguridad de tu cuenta.",
  "m_getting_started": "Inicio",
  "settings_sender_title": "Verificación de Dominios de Remitente  ",
  "settings_sender_add_domain": "Agregar Dominio",
  "settings_sender_description": "Para mejorar la entrega de sus correos electrónicos, simplemente autentique sus dominios de remitente con tres registros esenciales DNS.  ",
  "settings_sender_domains_empty": "Aún no tiene dominios de remitente verificados.<br>Por favor, verifique su primer dominio.",
  "settings_sender_if_unverified": "¿Qué pasa si el dominio del remitente no está verificado?",
  "settings_sender_notify_label": "Notificarme por email si el dominio del remitente no está verificado",
  "settings_sender_notify_email_label": "Email",
  "settings_sender_notify_email_tip": "Si el campo está vacío, la notificación se enviará a la dirección de su cuenta de turboSMTP.",
  "settings_sender_notify_email_error": "Por favor, introduzca una dirección de correo electrónico válida",
  "settings_sender_notify_email_placeholder": "Introduzca una dirección de correo electrónico...",
  "settings_sender_dns_title": "Cómo verificar su dominio",
  "settings_sender_dns_description": "Para nuestro servicio SMTP, necesita configurar los registros SPF y DKIM en sus dominios de remitente. Añadir un registro DMARC también es obligatorio para mejorar la seguridad y la entregabilidad de sus correos.",
  "settings_sender_spf_title": "Registro SPF",
  "settings_sender_spf_description": "Por favor, proceda agregando el registro TXT especificado al dominio del remitente, eligiendo una de las dos alternativas siguientes:",
  "settings_sender_dkim_title": "Registro DKIM",
  "settings_sender_dkim_description": "Para el DKIM, agregue el registro TXT proporcionado a la configuración DNS de su dominio, que contiene la clave pública utilizada para verificar que los correos enviados desde su dominio son legítimos y no han sido alterados durante el tránsito.",
  "settings_sender_dmarc_title": "Registro DMARC",
  "settings_sender_dmarc_description": "Complete el proceso de autenticación de sus correos electrónicos añadiendo el registro DMARC TXT a su DNS, estableciendo una política sobre cómo los receptores de correo deben tratar los mensajes que no pasen las verificaciones de SPF o DKIM, proporcionando así una capa adicional de defensa contra prácticas fraudulentas por correo.",
  "settings_sender_domain_added": "Dominio de remitente <strong>{domain}</strong> agregado.",
  "settings_sender_domain": "Dominio de remitente",
  "settings_sender_domains_name": "Nombre del dominio",
  "settings_sender_domains_action_verify": "Verificar",
  "settings_sender_domains_action_delete": "Eliminar",
  "settings_sender_domains_action_subaccount": "Subcuenta:",
  "settings_sender_action_delete_confirm_title": "Eliminar dominio",
  "settings_sender_action_delete_confirm_message": "¿Está seguro de querer eliminar el dominio <strong>{domainName}</strong>?",
  "settings_sender_domain_description": "Especifique el dominio del remitente que desea validar:",
  "settings_sender_verify_record": "Registro TXT",
  "settings_sender_verify_value": "Estado",
  "settings_sender_verify_ok": "Ok",
  "settings_sender_dns_ask_admin": "Por favor, contacte a su administrador de cuenta para verificar el dominio. Esta acción es requerida y solo puede ser realizada por el titular principal de la cuenta.",
  "settings_sender_verify_fail": "{type} no encontrado o no configurado correctamente ",
  "settings_sender_verified": "Su dominio está configurado correctamente. Puede enviar de manera segura usando este remitente.",
  "settings_sender_dkim_domain_title": "Dominio DKIM  ",
  "settings_sender_dkim_value_title": "Valor DKIM  ",
  "settings_sender_dmarc_domain_title": "Dominio DMARC  ",
  "settings_sender_dmarc_value_title": "Valor DMARC ",
  "settings_sender_domains_search_placeholder": "Filtrar dominios de remitente por nombre...",
  "settings_sender_domains_status_placeholder": "Verificación...",
  "settings_sender_domains_status_verified": "Verificado",
  "settings_sender_domains_status_not_verified": "No verificado",
  "settings_sender_domains_filters_no_results": "No se encontraron resultados con estos filtros",
  "block_unverified_sender_title": "Bloquear dominios de remitente no verificados",
  "block_unverified_sender_modal_title": "Dominios de remitente no verificados",
  "block_unverified_sender_desc": "Si el dominio del remitente no está verificado, bloquear el envío de correos y notificarme por correo",
  "block_unverified_sender_change": "Cambiar este comportamiento",
  "forward_as_received_title": "Enviar Sin Modificaciones",
  "forward_as_received_info": "Envíe sus correos electrónicos sin modificaciones, incluso desde dominios de remitente no verificados. Tome en cuenta que esto probablemente resultará en una <strong>alta tasa de rebote y baja entregabilidad</strong>, ya que sus correos podrían ser marcados como spam, afectando la reputación de su dominio.",
  "block_title": "Rechazar y Descartar",
  "block_info": "Elija esta opción para asegurarse de que no se envíen correos desde dominios de remitente no verificados. Los mensajes que no pasen las verificaciones de SPF, DKIM o DMARC serán eliminados automáticamente para <strong>mantener su reputación de envío</strong> y prevenir el riesgo de ser marcados como spam.",
  "fallback_to_turbo_title": "Re-sobrescribir Remitente",
  "fallback_to_turbo_info": "Opte por re-sobrescribir usando una dirección de turboSMTP como remitente para correos de dominios de remitente no verificados. Esto puede mejorar la entregabilidad, aunque el <strong>cambio en la dirección del remitente podría ser notado</strong> por los destinatarios en sus clientes de correo.",
  "notification_email_updated": "Correo de notificación actualizado.",
  "notification_email_enabled": "Correo de notificación habilitado.",
  "notification_email_disabled": "Correo de notificación deshabilitado.",
  "invalid_notification_email": "Correo de notificación no válido ",
  "settings_sender_domains_new_intro": "Introduzca la información del nuevo dominio",
  "paginator_page": "Página",
  "paginator_of": "de",
  "no_records_found": "Registro DNS no encontrado. Asegúrese de que el registro esté publicado correctamente y que la propagación se haya completado.",
  "invalid_record_found": "Se encontró un registro DNS, pero parece estar mal formateado o tiene un valor inválido.",
  "too_many_dns_lookups": "El registro SPF incluye más de 10 búsquedas DNS permitidas, lo que puede provocar problemas en la entrega de correos electrónicos.",
  "more_than_spf_entry_found": "Se detectaron múltiples registros SPF para su dominio. Solo se permite un solo registro SPF por dominio.",
  "settings_sender_loading_domain_data": "Cargando los resultados de la verificación del dominio...",
  "notice": "Aviso",
  "settings_sender_domains_no_option": "<p>Su cuenta opera actualmente bajo el \"Standard mode\", una <strong>configuración más antigua</strong> que reenvuelve todos los correos salientes con nuestra dirección de correo electrónico, independientemente de sus configuraciones de SPF, DKIM y DMARC.</p>\n<p>Para mejorar la entregabilidad de los correos electrónicos, recomendamos encarecidamente elegir una de las opciones de reserva actualizadas disponibles.</p>",
  "failed_to_get_a_aaaa_record": "Fallo al obtener registros A / AAAA para {domain_name}",
  "invalid_spf_syntax": "Sintaxis SPF inválida",
  "spf_has_upper_case_letters": "El registro SPF no debe contener letras mayúsculas. Por favor, asegúrese de que todos los caracteres estén en minúsculas para cumplir con la especificación SPF.",
  "recursive_include_detected": "Su registro SPF no debe incluir el dominio en sí, ya que esto crea un bucle que conduce a búsquedas DNS infinitas. Por favor, revise la entrada SPF para eliminar la referencia al dominio y evitar dependencias circulares y cumplir con la especificación SPF.",
  "spf_longer_than_255_characters": "El registro SPF supera el límite de 255 caracteres para una única cadena de texto DNS. Para cumplir con las especificaciones de DNS, divida su registro SPF en varias cadenas, cada una no excediendo los 255 caracteres, o acorte el registro para cumplir con el límite.",
  "ptr_mechanism_not_allowed": "Para optimizar el rendimiento de SPF y promover la adopción de prácticas robustas de verificación de remitentes, es aconsejable excluir el mecanismo ptr y confiar en su lugar en mecanismos como ip4 e include.",
  "data_location_modal_title": "Ubicación de datos",
  "data_location_network_servers": "Servidores de red",
  "data_location_ip_location": "Ubicación IP",
  "data_location_company_managing_data": "Empresa gestora de datos",
  "data_location_network_servers_value": "Milán (IT), Fráncfort (DE), Ámsterdam (NL)",
  "data_location_ip_location_value": "Europa RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl, Italia UE",
  "data_location_no_transfer_outside_eu": "No se transfieren datos fuera de la Unión Europea",
  "gdpr_data_location": "Datos en UE",
  "gdpr_see_details": "Detalles",
  "not_included_in_plan": "No incluido en tu plan actual",
  "registration_logout": "Cerrar sesión",
  "registration_step_personal": "Información Personal",
  "registration_step_company": "Información de la Empresa",
  "registration_step_address": "Dirección",
  "registration_label_email": "Correo electrónico",
  "registration_label_firstname": "Nombre",
  "registration_label_lastname": "Apellido",
  "registration_label_company": "Empresa",
  "registration_label_vat": "Número de IVA",
  "registration_label_vat_optional": "(Opcional)",
  "registration_label_phone": "Número de teléfono",
  "registration_label_website": "Sitio web",
  "registration_label_website_hint": "(Opcional)",
  "registration_label_address": "Dirección",
  "registration_label_city": "Ciudad",
  "registration_label_country": "País",
  "registration_placeholder_country": "Seleccionar país",
  "registration_label_region": "Estado / Región",
  "registration_placeholder_region": "Seleccionar región",
  "registration_label_zip": "Código Postal",
  "registration_btn_back": "Atrás",
  "registration_btn_next": "Siguiente Paso",
  "registration_btn_complete": "Completar Perfil",
  "registration_error_firstname": "El nombre es obligatorio.",
  "registration_error_lastname": "El apellido es obligatorio.",
  "registration_error_company": "La empresa es obligatoria.",
  "registration_error_phone": "El número de teléfono es obligatorio.",
  "registration_error_website": "Por favor, introduce una URL válida.",
  "registration_error_address": "La dirección es obligatoria.",
  "registration_error_city": "La ciudad es obligatoria.",
  "registration_error_country": "El país es obligatorio.",
  "registration_error_region": "La región es obligatoria.",
  "registration_error_zip": "El código postal es obligatorio.",
  "registration_error_phone_format": "El número de teléfono debe contener solo números.",
  "registration_address_message": "Al asegurarte de que tu dirección postal es correcta, podrás beneficiarte de una <strong>experiencia de activación acelerada</strong>.",
  "registration_step_confirmation": "Confirmación",
  "registration_confirmation_title": "¡Perfil completado!",
  "registration_confirmation_message": "Tu cuenta ha sido creada con éxito.<br>Ahora puedes comprar un plan para desbloquear funciones avanzadas y límites de envío más altos",
  "registration_confirmation_message_buy": "Tu cuenta ha sido creada con éxito.",
  "registration_btn_buy_plan": "Comprar un plan",
  "registration_stay_free": "Mantener la versión gratuita, podrá mejorar más tarde",
  "registration_btn_dashboard": "Ir al Panel de Control",
  "registration_redirect_to_shop": "Será redirigido al proceso de pago en un momento...",
  "registration_go_to_shop": "Haga clic aquí para proceder al pago",
  "button_yes_delete": "Sí, eliminar",
  "button_yes_revoke": "Sí, revocar"
}
